import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	isEqual, map, isUndefined, isFunction,
} from 'lodash';
import utils from '@utils';

class JobsListItem extends Component {
	shouldComponentUpdate = ({ job, active }) => {
		const lastProps = this.props;

		return (
			!isEqual(job, lastProps.job)
			|| !isEqual(active, lastProps.active)
		);
	}

	handleOnClick = () => {
		const {
			onClick,
			job : {
				Id,
				LocationLatitude,
				LocationLongitude,
			},
		} = this.props;

		if (!isUndefined(onClick) && isFunction(onClick)) onClick(Id, LocationLatitude, LocationLongitude);
	}

	getDateFormatted = (date, format = 'h:mm a') => {
		const { timeZoneId } = this.props;

		return utils.parseUTCDateToTimeZone(date, timeZoneId).format(format);
	}

	getPointsMapped = (type, array, property = 'CheckinDateTimeUTC') => (map(array, (dot, index) => (
		<li key={`dot_${type.replace(/\s/g, '_')}_${index}`}>
			<div className="font-light font-size-12">
				<strong>
					{ type }
					:
					{' '}
				</strong>
				{ this.getDateFormatted(dot[property], 'MM/DD/YYYY h:mm a') }
			</div>
			<div className="font-light font-size-12">
				<strong>Distance: </strong>
				{ parseFloat(dot.DistanceFromJob).toFixed(2) }
				{' '}
				miles
			</div>
		</li>
	)))

	render() {
		const {
			active,
			job : {
				ClientName,
				LocationAddress,
				LocationCityStateZip,
				StartDateTime,
				EndDateTime,
			},
		}		= this.props;

		return (
			<div className={classNames('job', { active })}>
				<div
					className="header"
					onClick={this.handleOnClick}
					role="link"
					onKeyPress={null}
					tabIndex={0}
				>
					<h5>{ ClientName }</h5>
					<p>
						{ LocationAddress }
						,
						{' '}
						{ LocationCityStateZip }
					</p>
					<p>
						Job:
						{ this.getDateFormatted(StartDateTime) }
						-
						{ this.getDateFormatted(EndDateTime) }
					</p>
				</div>
			</div>
		);
	}
}

JobsListItem.propTypes = {
	active     : PropTypes.bool.isRequired,
	job        : PropTypes.object.isRequired,
	onClick    : PropTypes.func.isRequired,
	timeZoneId : PropTypes.string,
};

JobsListItem.defaultProps = {
	timeZoneId : '',
};

export default JobsListItem;
